import * as React from 'react'

import useLocale from '@/hooks/use-locale'

import { PageHeader, PageHeaderDescription, PageHeaderHeading } from '@/components/common/page-header'
import { Shell } from '@/components/common/shell'
import ViewTracker from '@/components/common/view-tracker'
import ContactSection from '@/components/sections/contact-section'
import SEO from '@/components/seo/SEO'
import HallOfFameContainer from '@/containers/hall-of-fame/hall-of-fame-container'
import RootContainer from '@/containers/root-container'


function HallOfFamePage() {

  return (
    <RootContainer>
      <SEO title="Hall of Fame" />
      <ViewTracker entityType="page" entityId="/hall-of-fame" />
      <HallOfFameHeroSection />
      <HallOfFameContainer />
      <ContactSection className="mt-0 sm:mt-0 md:mt-0 mb-8 sm:mb-12 md:mb-20" />
    </RootContainer>
  )
}

function HallOfFameHeroSection() {
  const { text } = useLocale()
  return (
    <Shell className="sm:pb-12 pb-0 lg:pb-0 min-h-[360px] lg:min-h-[480px] bg-background">
      <PageHeader className="space-y-4 mx-auto items-center gap-2 text-center">
        <PageHeaderHeading>Hall of Fame</PageHeaderHeading>
        <PageHeaderDescription>{text.HALL_OF_FAME.DESCRIPTION}</PageHeaderDescription>
      </PageHeader>
    </Shell>
  )
}

export default HallOfFamePage
